<svelte:options
  customElement={{
    tag: "oc-badge-v1",
    /*                                            */
    extend: window.__components.extend(),
    props: {
      size: { type: "String" },
      variant: { type: "String" },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./BadgeV1.types.js";
  import DefaultStyles from "../../../common/components/DefaultStyles/DefaultStyles.svelte";

  let { variant = "primary", size = "100" }: Props = $props();
</script>

<div class="badge {`badge--type-${variant}`} {`badge--size-${size}`}">
  {#if size === "100"}
    {#if variant === "success"}
      <oc-icon-v1 size={/*                      */ "50"} type="check"></oc-icon-v1>
    {:else}
      <slot />
    {/if}
  {/if}
</div>

<DefaultStyles />

<style lang="scss">
  @use "@otto-ec/design-tokens/component" as tokens;
  @use "@otto-ec/otto-components-utils/scss/mixins";
  :global {
    :host {
      display: inline-block;
      vertical-align: top; /*                                                                                 */
    }

    .badge {
      height: tokens.$oc-component-badge-100-height;
      color: tokens.$oc-component-badge-100-text-color;
      font: tokens.$oc-component-badge-100-font;
      text-align: center;
      line-height: tokens.$oc-component-badge-100-height;
      outline: tokens.$oc-component-badge-border-color solid tokens.$oc-component-badge-border-width;
      border-radius: tokens.$oc-component-badge-100-border-radius;
      padding: 0 4px;

      &--type-primary {
        background-color: tokens.$oc-component-badge-primary-background-color;
      }
      &--type-secondary {
        background-color: tokens.$oc-component-badge-secondary-background-color;
      }
      &--type-success {
        padding: 0 2px;
        background-color: tokens.$oc-component-badge-success-background-color;

        oc-icon-v1 {
          height: 1rem;
        }
      }

      &--size-100 {
        min-width: tokens.$oc-component-badge-100-min-width;
      }

      &--size-50 {
        height: tokens.$oc-component-badge-50-height;
        width: tokens.$oc-component-badge-50-height;
        border-radius: 50%;
        background-color: tokens.$oc-component-badge-primary-background-color;
      }
    }
  }
</style>
